import { SvgIcon, SvgIconTypeMap } from "@mui/material";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";

/**
 * 
 * Icon of Liquid
 * 
 * ###Import to use it
 *
 *`import { LiquidIcon } from '@eco/react-lib'`
 *
 *### Usage
 *
 *`<LiquidIcon />`
 *
 *### Basic Example
 */

export const LiquidIcon = (props: DefaultComponentProps<SvgIconTypeMap<{}, "svg">>) => (
    <SvgIcon {...props}>
        <path d="M8.5,1.8c-0.3-1.1-1.9-1.2-2.3,0C4.4,8,0.5,9.6,0.5,14c0,3.8,3.1,7,6.9,7c3.8,0,6.9-3.1,6.9-7C14.2,9.6,10.4,8,8.5,1.8
            M7.4,18.4c-2.4,0-4.4-2-4.4-4.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,1.7,1.4,3.1,3.1,3.1c0.3,0,0.6,0.3,0.6,0.6
            C8,18.2,7.7,18.4,7.4,18.4"/>
    </SvgIcon>
)
